function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isObject } from 'vega';
import { parseSelector } from 'vega-event-selector';
import { array, isString } from 'vega-util';
import { disableDirectManipulation, TUPLE } from '.';
import * as log from '../../log';
import { isLegendBinding, isLegendStreamBinding, SELECTION_ID } from '../../selection';
import { duplicate, vals, varName } from '../../util';
import { TUPLE_FIELDS } from './project';
import { TOGGLE } from './toggle';
var legendBindings = {
  defined: function defined(selCmpt) {
    var spec = selCmpt.resolve === 'global' && selCmpt.bind && isLegendBinding(selCmpt.bind);
    var projLen = selCmpt.project.items.length === 1 && selCmpt.project.items[0].field !== SELECTION_ID;
    if (spec && !projLen) {
      log.warn(log.message.LEGEND_BINDINGS_MUST_HAVE_PROJECTION);
    }
    return spec && projLen;
  },
  parse: function parse(model, selCmpt, selDef) {
    // Allow legend items to be toggleable by default even though direct manipulation is disabled.
    var selDef_ = duplicate(selDef);
    selDef_.select = isString(selDef_.select) ? {
      type: selDef_.select,
      toggle: selCmpt.toggle
    } : _objectSpread(_objectSpread({}, selDef_.select), {}, {
      toggle: selCmpt.toggle
    });
    disableDirectManipulation(selCmpt, selDef_);
    if (isObject(selDef.select) && (selDef.select.on || selDef.select.clear)) {
      var legendFilter = 'event.item && indexof(event.item.mark.role, "legend") < 0';
      var _iterator = _createForOfIteratorHelper(selCmpt.events),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _evt$filter;
          var _evt = _step.value;
          _evt.filter = array((_evt$filter = _evt.filter) !== null && _evt$filter !== void 0 ? _evt$filter : []);
          if (!_evt.filter.includes(legendFilter)) {
            _evt.filter.push(legendFilter);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    var evt = isLegendStreamBinding(selCmpt.bind) ? selCmpt.bind.legend : 'click';
    var stream = isString(evt) ? parseSelector(evt, 'view') : array(evt);
    selCmpt.bind = {
      legend: {
        merge: stream
      }
    };
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    var selName = selCmpt.name;
    var stream = isLegendStreamBinding(selCmpt.bind) && selCmpt.bind.legend;
    var markName = function markName(name) {
      return function (s) {
        var ds = duplicate(s);
        ds.markname = name;
        return ds;
      };
    };
    var _iterator2 = _createForOfIteratorHelper(selCmpt.project.items),
      _step2;
    try {
      var _loop = function _loop() {
        var proj = _step2.value;
        if (!proj.hasLegend) return 1; // continue
        var prefix = "".concat(varName(proj.field), "_legend");
        var sgName = "".concat(selName, "_").concat(prefix);
        var hasSignal = signals.filter(function (s) {
          return s.name === sgName;
        });
        if (hasSignal.length === 0) {
          var events = stream.merge.map(markName("".concat(prefix, "_symbols"))).concat(stream.merge.map(markName("".concat(prefix, "_labels")))).concat(stream.merge.map(markName("".concat(prefix, "_entries"))));
          signals.unshift(_objectSpread(_objectSpread({
            name: sgName
          }, !selCmpt.init ? {
            value: null
          } : {}), {}, {
            on: [
            // Legend entries do not store values, so we need to walk the scenegraph to the symbol datum.
            {
              events: events,
              update: 'isDefined(datum.value) ? datum.value : item().items[0].items[0].datum.value',
              force: true
            }, {
              events: stream.merge,
              update: "!event.item || !datum ? null : ".concat(sgName),
              force: true
            }]
          }));
        }
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;
    var tuple = _signals.find(function (s) {
      return s.name === name + TUPLE;
    });
    var fields = name + TUPLE_FIELDS;
    var values = proj.items.filter(function (p) {
      return p.hasLegend;
    }).map(function (p) {
      return varName("".concat(name, "_").concat(varName(p.field), "_legend"));
    });
    var valid = values.map(function (v) {
      return "".concat(v, " !== null");
    }).join(' && ');
    var update = "".concat(valid, " ? {fields: ").concat(fields, ", values: [").concat(values.join(', '), "]} : null");
    if (selCmpt.events && values.length > 0) {
      tuple.on.push({
        events: values.map(function (signal) {
          return {
            signal: signal
          };
        }),
        update: update
      });
    } else if (values.length > 0) {
      tuple.update = update;
      delete tuple.value;
      delete tuple.on;
    }
    var toggle = _signals.find(function (s) {
      return s.name === name + TOGGLE;
    });
    var events = isLegendStreamBinding(selCmpt.bind) && selCmpt.bind.legend;
    if (toggle) {
      if (!selCmpt.events) toggle.on[0].events = events;else toggle.on.push(_objectSpread(_objectSpread({}, toggle.on[0]), {}, {
        events: events
      }));
    }
    return _signals;
  }
};
export default legendBindings;
export function parseInteractiveLegend(model, channel, legendCmpt) {
  var _model$fieldDef, _model$component$sele;
  var field = (_model$fieldDef = model.fieldDef(channel)) === null || _model$fieldDef === void 0 ? void 0 : _model$fieldDef.field;
  var _iterator3 = _createForOfIteratorHelper(vals((_model$component$sele = model.component.selection) !== null && _model$component$sele !== void 0 ? _model$component$sele : {})),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _selCmpt$project$hasF;
      var selCmpt = _step3.value;
      var proj = (_selCmpt$project$hasF = selCmpt.project.hasField[field]) !== null && _selCmpt$project$hasF !== void 0 ? _selCmpt$project$hasF : selCmpt.project.hasChannel[channel];
      if (proj && legendBindings.defined(selCmpt)) {
        var _legendCmpt$get;
        var legendSelections = (_legendCmpt$get = legendCmpt.get('selections')) !== null && _legendCmpt$get !== void 0 ? _legendCmpt$get : [];
        legendSelections.push(selCmpt.name);
        legendCmpt.set('selections', legendSelections, false);
        proj.hasLegend = true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}